import { render, staticRenderFns } from "./home.vue?vue&type=template&id=3cc08f7e&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style1 from "./home.vue?vue&type=style&index=1&id=3cc08f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc08f7e",
  null
  
)

export default component.exports